module.exports = __webpack_public_path__ + "img/003_08.f6c03cc1.jpg";